module.exports = __webpack_public_path__ + "static/img/14.2ae0dc5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/73/new/14.png
// module id = M4by
// module chunks = 0